import m from "../../../../geodata/es2015/region/world/worldRegionsUltra";
window.am4geodata_region_world_worldRegionsUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/worldRegionsUltra.js
// module id = null
// module chunks = 